export type ConsentConfigOnFeatureV1 =
  | ConsentFeatureOnboardingType
  | ConsentFeatureTelehealthType
  | ConsentFeatureAnalyticsType;

type ConsentFeatureOnboardingType = {
  type: ConsentFeatureType.ON_ONBOARDING;
};

type ConsentFeatureTelehealthType = {
  type: ConsentFeatureType.TELEHEALTH;
};

type ConsentFeatureAnalyticsType = {
  type: ConsentFeatureType.ANALYTICS;
};

export enum ConsentFeatureType {
  ON_ONBOARDING = 'ON_ONBOARDING',
  TELEHEALTH = 'TELEHEALTH',
  ANALYTICS = 'ANALYTICS',
}
